<template>
    <div class="page">
        <div class="page__header">
            <div class="page__header-title">
                New Push Notification
            </div>
            <div class="page__header-tools"></div>
        </div>
        <div class="page__body">
            <section class="push-notifiacation">
                <div class="notification-form">
                    <form ref="form" autocomplete="off" @submit.prevent="addNewNotification()">
                        <hr />
                        <div class="row">
                            <div class="col-lg-8">
                                <div class="form-group">
                                    <label for="exampleInputEmail1">Message Name</label>
                                    <input type="text" class="form-control" placeholder="Message Name"
                                        v-model="messageName" />
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="card">
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-lg-6">
                                                <div class="card-title">
                                                    <div class="form-group">
                                                        <label>Title</label>
                                                        <input type="text" class="form-control" placeholder="Title"
                                                            v-model="title">
                                                    </div>
                                                    <div class="form-group">
                                                        <label>Message</label>
                                                        <textarea class="form-control" id="exampleFormControlTextarea1"
                                                            rows="2" v-model="message"></textarea>
                                                    </div>
                                                    <div class="form-group">
                                                        <label>Image Url</label>
                                                        <input type="text" class="form-control" placeholder="Image Url"
                                                            v-model="imageurl">
                                                    </div>
                                                    <div class="form-group">
                                                        <label>url</label>
                                                        <input type="text" class="form-control" placeholder="url"
                                                            v-model="url">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-lg-6">
                                                <div class="right-img">
                                                    <div class="row">
                                                        <android-preview
                                                        :text-body="this.message"
                                                        text-title=""
                                                        :text-application-name="this.title" text-time="0m" />
                                                        <iphone-preview 
                                                        :text-body="this.message"
                                                        text-title=""
                                                        :text-application-name="this.title" text-time="0m" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <b-row>
                            <b-col cols="3">
                                <b-button class="form__button_left" size="sm" variant="light"
                                    @click="cancel()">Cancel</b-button>
                                <b-button class="form__button_right" size="sm" variant="success" type="submit">Add
                                    Notification</b-button>
                            </b-col>
                        </b-row>

                    </form>
                </div>
            </section>
            <div class="form-hidden-video">
                <video id="hidden__video" :src="url" hidden controls></video>
            </div>
        </div>
    </div>
</template>
  
<script>
import API from "../api.js"
import { AndroidPreview, IphonePreview } from 'vue-push-notification-preview';
import 'vue-push-notification-preview/src/assets/devices.scss';

export default {
    data: function () {
        return {
            messageName: '',
            url: '',
            imageurl: '',
            message: '',
            title: ''
        };
    },

    components: {
        AndroidPreview,
        IphonePreview
    },

    methods: {


        async addNewNotification() {
            const notificationData = {
                name: this.messageName,
                body: {
                    "title": this.title,
                    "options": {
                        "body": this.message,
                        "icon": "manifest/icon-512x512.png",
                        "badge": "manifest/icon-256x256.png",
                        "vibrate": [200, 100, 200],
                        "data": {
                            "link": this.url
                        }
                    }
                },
                type: 'BrowserNotification',
                priority: 'Promotional',
            }
            API.addNotification(notificationData).then(() => {
                // this.addingVideo = false;
            });
        },

        cancel() {
            this.$router.push("/admin/notification");
        },
    },
};
</script>
  
<style scoped>
.push-notifiacation .btn.btn-primary {
    background-color: #4342cf;
    border-color: #4342cf;
    margin-top: 20px;
    outline: none !important;
    box-shadow: none;
}

.notification-form .form-group>label {
    margin-bottom: 15px;
}

.notification-form .card-title h5 {
    position: relative;
    padding-left: 20px;
    font-size: 16px;
    font-weight: 400px;
    color: #4342cf;
}

.notification-form .card-title h5:after {
    content: '';
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='%234543da' class='bi bi-globe-americas' viewBox='0 0 16 16'%3E%3Cpath d='M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0ZM2.04 4.326c.325 1.329 2.532 2.54 3.717 3.19.48.263.793.434.743.484-.08.08-.162.158-.242.234-.416.396-.787.749-.758 1.266.035.634.618.824 1.214 1.017.577.188 1.168.38 1.286.983.082.417-.075.988-.22 1.52-.215.782-.406 1.48.22 1.48 1.5-.5 3.798-3.186 4-5 .138-1.243-2-2-3.5-2.5-.478-.16-.755.081-.99.284-.172.15-.322.279-.51.216-.445-.148-2.5-2-1.5-2.5.78-.39.952-.171 1.227.182.078.099.163.208.273.318.609.304.662-.132.723-.633.039-.322.081-.671.277-.867.434-.434 1.265-.791 2.028-1.12.712-.306 1.365-.587 1.579-.88A7 7 0 1 1 2.04 4.327Z'/%3E%3C/svg%3E");
    width: 15px;
    height: 15px;
    left: 0;
    position: absolute;
    background-size: contain;
    top: 3px;
}

.notification-form .input-group-text {
    background-color: transparent;
    color: #4342cf;
}

.custom-file-label::after {
    background-color: transparent;
    color: #4342cf;
}

.right-img img {
    max-width: 100%;
}
</style>
  